import { render, staticRenderFns } from "./LicensedGoods.vue?vue&type=template&id=15edcad4&scoped=true"
import script from "./LicensedGoods.vue?vue&type=script&lang=js"
export * from "./LicensedGoods.vue?vue&type=script&lang=js"
import style0 from "./LicensedGoods.vue?vue&type=style&index=0&id=15edcad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edcad4",
  null
  
)

export default component.exports